import { GreyGrey40, Spinner, Center, Box } from '@sequencehq/core-components'

export const WidgetLoading = () => {
  return (
    <Box
      width="390px"
      minHeight="291px"
      boxShadow="0 2px 4px 0 rgba(15, 23, 42, 0.08)"
      border={`1px solid ${GreyGrey40}`}
      borderRadius="lg"
      p={4}
    >
      <Center width="100%" height="100%">
        <Spinner color="gray.100" />
      </Center>
    </Box>
  )
}
